import { render, staticRenderFns } from "./UserGridRecruiter.vue?vue&type=template&id=028c73d7&"
import script from "./UserGridRecruiter.vue?vue&type=script&lang=js&"
export * from "./UserGridRecruiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports